import { PAGE_SIZE } from '../../../constants/Config';
import {
    SERVICE_PRODUCT_DELETE,
    SERVICE_PRODUCT_DETAIL,
    SERVICE_PRODUCT_INSERT,
    SERVICE_PRODUCT_LIST,
    SERVICE_PRODUCT_UPDATE,
    SERVICE_PRODUCT_SELECT
} from './action-types';

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: {},
    selectedService: null
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case SERVICE_PRODUCT_SELECT:
            return select(state, payload);
        case SERVICE_PRODUCT_LIST:
            return list(state, payload);
        case SERVICE_PRODUCT_DETAIL:
            return detail(state, payload);
        case SERVICE_PRODUCT_UPDATE:
            return update(state, payload);
        case SERVICE_PRODUCT_INSERT:
            return insert(state, payload);
        case SERVICE_PRODUCT_DELETE:
            return deletes(state, payload);
        default:
            return state;
    }
};

function select(state, payload) {
    state = Object.assign({}, state, {
        selectedService: payload
    });
    return state;
}

function list(state, payload) {
    return { ...state, ...payload };
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    });
    return state;
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.UserId !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload };
        }
        return obj;
    });

    return Object.assign({}, state, { data });
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data });
}

export const getServiceProductsList = state => state.serviceProduct.data;

export default reducer;
